<template>
    <c-dialog ref="dialog" width="450" height="350" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="商户代码">
                <c-input type="number" name="saas_id" disabled></c-input>
            </c-form-item>
            <c-form-item label="商户名称">
                <c-input name="saas_full_name" disabled></c-input>
            </c-form-item>
            <c-form-item label="评分" tip="商户评分最高5分最低0分，允许保留1位小数">
                <c-input type="number" name="saas_score"  decimal="1" :range="[0,5]" placeholder="请输入商户评分"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name:'saasScoreEdit',
    data() {
        return {
            is_open_jldhs:0,
            isOpenJldhsOptions:[
                {
                    name: '开通',
                    value: 1,
                    color: 'green'
                },
                {
                    name: '关闭',
                    value: 0,
                    color: 'gray'
                }
            ]
        }
    },
    computed: {
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
            }
            //填充form表单
            this.$refs.dialog.open({
                title: '编辑商户评分'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/sys_saas/edit/saas_score',
                rule: {
                    saas_score: '请输入商户评分'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>